/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo, useState } from 'react';

import { Box, Grid, Stack, Tab, Tabs } from '@mui/material';
import { useParams } from 'react-router-dom';

import PdfView from './PdfView';
import Sections from './Sections';
import { a11yProps } from '../../components/CustomTabPanel';
import { riPrimary } from '../../components/Theme/colors';
import {
  useGetDocumentQuery,
  useGetDraftQuery,
} from '../../redux/services/draftApi';

const innerTabStyle = {
  backgroundColor: riPrimary[10],
  borderRadius: '20px',
  paddingX: '15px',
};

const tabs = [
  {
    label: 'Issues',
    value: 'issues',
  },
  {
    label: 'Insights',
    value: 'insights',
  },
  {
    label: 'Clause Library',
    value: 'clause-library',
  },
];

const ViewDraft = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState<string>('issues');

  const { data: document, isLoading } = useGetDocumentQuery({
    draft_id: id,
  });

  const { data: draft } = useGetDraftQuery(id || '', { skip: !id });

  const fileLink = useMemo(() => (document as any)?.presigned_url, [document]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Grid container sx={{ mt: 2 }}>
        <Grid item sm={6}>
          {!isLoading && (
            <PdfView key={fileLink} fileLink={fileLink} draftDetails={draft} />
          )}
        </Grid>
        <Grid item sm={6} sx={{ paddingLeft: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="Draft tabs"
            variant="scrollable"
            scrollButtons={false}
            sx={innerTabStyle}
          >
            {tabs.map((tab: any, index: number) => (
              <Tab
                key={index}
                label={tab.label}
                value={tab.value}
                {...a11yProps(tab.value)}
              />
            ))}
          </Tabs>

          <Stack
            spacing={1}
            sx={{
              height: '80vh',
              overflowY: 'auto',
              backgroundColor: 'riTertiary.50',
              borderRadius: '24px',
              padding: '8px',
              mt: '8px',
            }}
          >
            <Sections id={id} activeTab={activeTab} />
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ViewDraft;
